module.exports = __webpack_public_path__ + "assets/img/eye.e4fe315c.svg";